import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from 'antd';
import { ListWidget } from '../../../components/ListWidget';
import Search from '../../../components/Search';
import { DocumentListItem } from '../DocumentListItemBuilder';
import NewDocumentModal from '../components/NewDocumentModal';
import { loadUserDocs } from '../actions/documentActions';
import * as SearchUtils from '../../../utils/search-utils';

class UserDocumentView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isNewDocumentModalVisible: false,
            searchMatches: null,
            docList: [],
            loading:true
        }
        this.loadDocList();
    }

    loadDocList = async() => {
        this.props.loadUserDocs();
    }

    getDocumentsForListView = () => {
        let documentList = this.filterDocuments().map((doc, index) => {
            let builder = new DocumentListItem.Builder(doc, true);
            return builder.build();
        });
        return documentList;
    }

    handleNewDocumentModalClose = () => {
        this.setState({ isNewDocumentModalVisible: false });
    }

    handleNewDocumentModalSave = () => {
        this.setState({ isNewDocumentModalVisible: false });
        this.loadDocList();
    }

    openNewDocumentModal = () => {
        this.setState({ isNewDocumentModalVisible: true });
    }

    filterDocuments = () => {
        return SearchUtils.filter(this.props.userDocuments ? this.props.userDocuments : [], "id", this.state.searchMatches);
    }

    filterSearchOptions() {
        const docs = this.filterDocuments();
        const optionsMap = { title: "Documents", children: [] };
        docs.forEach((doc) => {
            optionsMap.children.push({ title: doc.title, id: doc.id });
        });

        return [optionsMap];
    }

    onSearch = (phrase) => {
        let matches = SearchUtils.search(this.props.userDocumentIndex, phrase);
        this.setState({ searchMatches: matches });
    }

    onSearchSelect = (dId) => {
        this.setState({ searchSelectedDocumentId: dId });
    }

    goToSelectedDocument = () => {
        if (this.state.searchSelectedDocumentId) {
            //    return (<Redirect to={`/app/contractors/contractor_details/${this.state.searchSelectedContractorId}`} />);
        }
        return null;
    }

    render() {
        return (
            <div>
                <NewDocumentModal
                    visible={this.state.isNewDocumentModalVisible}
                    onCancel={this.handleNewDocumentModalClose}
                    onSave={this.handleNewDocumentModalSave}
                    isUserDoc={true}
                />
                <div className="pure-g">
                    <div className="pure-u-1-3">
                        <Search
                            searchText={"Search"}
                            handleSearch={(value) => this.onSearch(value)}
                            handleSelect={(value) => this.onSearchSelect(value)}
                            options={this.filterSearchOptions()}
                        />
                    </div>
                    <div className="pure-u-1 pure-u-md-2-3">
                        <Button onClick={() => this.openNewDocumentModal()} className='epar__tasks__action--button'>
                            {"Add New Document"}
                        </Button>
                    </div>
                </div>
                <div className="pure-g" style={{ marginTop: 10 }}>
                    <div className="pure-u-1">
                        <ListWidget data={this.getDocumentsForListView()} loading={this.props.userDocuments===undefined} />
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    return {
        userDocuments: state.getIn(["documentState", "userDocuments"]),
        userDocumentIndex: state.getIn(["documentState", "userDocumentIndex"])
    }
}

function mapDispatchToProps(dispatch) {
    return {
        loadUserDocs: bindActionCreators(loadUserDocs, dispatch)
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(UserDocumentView);